import { useController } from 'react-hook-form';
import {
  getPropertyClassificationOption,
  getPropertyClassificationSelection,
} from '../../utils/property-classification.util';
import Select from 'src/modules/shared/components/atoms/inputs/select';
import type { PropertyTypeSelectProps } from '../../types/property-classification.types';

/** Selects a property classification without exposing a second dropdown. */
export const PropertyTypeSelect = ({
  control,
  options,
}: PropertyTypeSelectProps) => {
  const { field: typeField } = useController({ control, name: 'propertyType' });
  const { field: subtypeField } = useController({
    control,
    name: 'propertySubtype',
  });
  return (
    <Select
      options={options}
      value={
        getPropertyClassificationOption(typeField.value, subtypeField.value)
          .value
      }
      onChange={(event) => {
        const selected = getPropertyClassificationSelection(event.target.value);
        typeField.onChange(selected.propertyType);
        subtypeField.onChange(selected.propertySubtype);
      }}
    />
  );
};
